import React from 'react';
import type { Outcome } from '../../types/activity';
import { outcomeLabel } from '../../utils/timeline';
interface OutcomeTagProps {
  outcome: Outcome;
  quiet?: boolean;
}
const TONE: Record<Outcome, string> = {
  connected: 'text-pos',
  received: 'text-pos',
  voicemail: 'text-warn',
  'no-answer': 'text-ink-subtle',
  sent: 'text-ink-muted',
  completed: 'text-ink-subtle'
};
const DOT: Record<Outcome, string> = {
  connected: 'bg-pos',
  received: 'bg-pos',
  voicemail: 'bg-warn',
  'no-answer': 'bg-line-strong',
  sent: 'bg-line-strong',
  completed: 'bg-line-strong'
};
export function OutcomeTag({
  outcome,
  quiet = false
}: OutcomeTagProps) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap text-[12px] ${quiet ? 'text-ink-subtle' : TONE[outcome]}`} data-id="element-55" data-mp="30ubbev3epv6t">
      <span className={`h-1.5 w-1.5 rounded-full ${DOT[outcome]}`} data-id="element-56" data-mp="z0lipc902ips" />
      {outcomeLabel(outcome)}
    </span>;
}